export default [{
  path: '/ProjectInfo',//简介
  name: 'infoPPage',
  meta: {
        
        title: '简介_项目对接_中国国际投资贸易洽谈会'
      },
  component: () => import('@/view/Project/info.vue')
},{
  path: '/ProjectSearch',//项目查询、投资商查询
  name: 'proSearchPage',
  meta: {
        
        title: '项目查询_项目对接_中国国际投资贸易洽谈会'
      },
  component: () => import('@/view/Project/ProjectSearch.vue')
},
{
  path: '/ProjectAnswer',//项目对接问答
  name: 'proAnswerPage',
  meta: {
        
        title: '项目对接问答_项目对接_中国国际投资贸易洽谈会'
      },
  component: () => import('@/view/Project/ProjectAnswer.vue')
}
]




// WEBPACK FOOTER //
// ./src/router/Project.js